<template>
    <v-dialog @click:outside="onCancel" :value="showDialog" :max-width="maxWidth">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <slot></slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="btnCancel" text @click="onCancel">
            <v-icon small left  v-if="btnCancelIcon">{{ btnCancelIcon }}</v-icon>
            {{ btnCancel }}
          </v-btn>
          <v-btn v-if="btnOk" text @click="onOk">
            <v-icon small left v-if="btnOkIcon">{{ btnOkIcon }}</v-icon>
            {{ btnOk }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
name: "DialogBrowserSupport",
  props: {
    showDialog: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: '450px',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    btnOk: {
      type: String,
      default: 'OK',
    },
    btnOkIcon: {
      type: String,
      default: 'mdi-check',
    },
    btnCancel: {
      type: String,
      default: 'Cancel',
    },
    btnCancelIcon: {
      type: String,
      default: 'mdi-close',
    },
  },
  data: () => ({

  }),
  mounted() {

  },
  methods: {
   onCancel(){
     this.$emit("update:showDialog", false);
     this.$emit('cancel');
   },
    onOk(){
      this.$emit("update:showDialog", false);
      this.$emit('ok');
    }
  }
}

</script>

<style scoped>

</style>